<template>
  <dl v-if="_g_IsUserLogged && !_g_User.is_only_authenticated_user" class="legacy-mobile-key-values">
    <div v-for="item in values" :key="item.label"><dt>{{ item.label }}</dt><dd>{{ item.value }}</dd></div>
  </dl>
</template>
<script>
import { mapGetters } from 'vuex';
import { hasNoEntry } from '../models/legacyPreferenceFormatting';
export default {
  computed: {
    ...mapGetters(['_g_SelectedTicker', '_g_User', '_g_IsUserLogged']),
    values() {
      const stock = this._g_SelectedTicker || {};
      const roles = this._g_User.roles || {};
      const restricted = roles[20] || roles[21];
      // No entry (SE): the API placeholders become '—' through format().
      const entry = value => hasNoEntry(stock) ? null : value;
      const percent = value => value == null || value === '' || !Number.isFinite(Number(value)) ? '—' : this.format(value) + ' %';
      return [
        { label: 'Ticker', value: stock.ticker || '—' },
        { label: 'T. entrada', value: stock.entry_type_name || '—' },
        { label: 'Acciones', value: this.format(entry(stock.instrument_number)) },
        { label: 'Entrada', value: this.format(entry(stock.real_entry)) },
        { label: 'Stop', value: this.format(stock.out_price) },
        { label: 'Soporte', value: this.format(stock.soport) },
        { label: 'Fecha sop.', value: restricted ? 'Sin acceso' : stock.data_soport || '—' },
        { label: 'Montante', value: this.format(entry(stock.amount)) },
        { label: 'Divisa', value: this.format(stock.cotitzacio_divisa) },
        { label: 'Rentab.', value: restricted ? 'Sin acceso' : percent(stock.tae_lt) }
      ];
    }
  },
  methods: {
    format(value) {
      return value == null || value === '' || !Number.isFinite(Number(value)) ? '—' : Number(value).toLocaleString('es-ES', { maximumFractionDigits: 2 });
    }
  }
};
</script>
